// Produktionszeit im Warenkorb (20.09.2026).
// Markup: snippets/rxk-bearbeitung-hinweis.liquid
//
// Die Zeile steht schon im HTML und nennt den Bestellschluss. Dieses Skript
// tauscht den Satz nur aus, wenn die Bearbeitungszeit vom Normalwert abweicht
// oder eine Werkstattpause eingetragen ist. Antwortet die App nicht, bleibt der
// Satz aus Liquid stehen — im Zweifel lieber die normale Aussage als keine.
//
// Warum eine eigene Datei und kein <script> im Snippet: Die Warenkorb-Schublade
// holt ihren Inhalt nach dem Hinzufuegen ueber die Section-Rendering-API und
// setzt ihn per innerHTML ein. Darin fuehrt der Browser keine <script>-Bloecke
// aus — das Element waere dort nie definiert.
//
// Dieselbe Antwort nutzt das Lieferfenster auf der Produktseite
// (rxk-lieferzeit.js), deshalb derselbe Schluessel im sessionStorage.
if (!customElements.get('rxk-bearbeitungshinweis')) {
  customElements.define(
    'rxk-bearbeitungshinweis',
    class extends HTMLElement {
      #observer;
      #revision = 0;

      connectedCallback() {
        this.hidden = true;
        this.#observer = new MutationObserver(() => this.refresh());
        this.#observer.observe(this, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-addon-tage', 'data-normal', 'data-url', 'data-vorbestellung', 'hidden'] });
        // 'hidden' (25.10.2026): Nach einer Mengenänderung gleicht Horizon das Element mit dem
        // neuen HTML ab und setzt dabei hidden wieder — ohne neues connectedCallback blieb
        // die Zeile dann unsichtbar. Jetzt löst das eine neue Prüfung aus.
        this.refresh();
      }

      disconnectedCallback() {
        this.#observer?.disconnect();
        this.#revision++;
      }

      async refresh() {
        const revision = ++this.#revision;
        const d = this.dataset;
        // Vorbestellung im Warenkorb: Der Satz aus Liquid nennt den Versandtermin,
        // die Bearbeitungszeit aus dem Backend spielt dann keine Rolle.
        if (d.vorbestellung) {
          this.hidden = false;
          return;
        }
        if (!d.url) return;
        const schluessel = 'rxk-bearbeitung';
        let daten = null;
        try {
          const gemerkt = JSON.parse(sessionStorage.getItem(schluessel) || 'null');
          if (gemerkt && Date.now() - gemerkt.at < 2 * 60 * 1000) daten = gemerkt.wert;
        } catch (e) {
          /* ohne Speicher eben frisch holen */
        }
        if (!daten) {
          try {
            const abbruch =
              typeof AbortSignal !== 'undefined' && AbortSignal.timeout ? { signal: AbortSignal.timeout(4000) } : {};
            const antwort = await fetch(d.url, abbruch);
            if (!antwort.ok) return;
            daten = await antwort.json();
            try {
              sessionStorage.setItem(schluessel, JSON.stringify({ at: Date.now(), wert: daten }));
            } catch (e) {
              /* egal */
            }
          } catch (e) {
            return;
          }
        }
        if (!this.isConnected || revision !== this.#revision || !daten || daten.hinweis === false) return;
        const feld = this.querySelector('.rxk-bh__text');
        if (!feld) return;
        const normal = Number(d.normal) || 0;
        // Zusatztage der Add-ons im Warenkorb. Sie stehen schon im Satz aus
        // Liquid; hier muessen sie mitgerechnet werden, damit die Zahl auch
        // stimmt, wenn zusaetzlich hohe Auslastung herrscht.
        const addon = Number(d.addonTage) || 0;
        const basis = daten.werktage == null ? normal : Number(daten.werktage);
        const jetzt = basis + addon;
        const heute = new Date().toISOString().slice(0, 10);
        if (daten.pause_bis && daten.pause_bis >= heute && d.textPause) {
          const datum = new Intl.DateTimeFormat(document.documentElement.lang || 'de', {
            day: 'numeric',
            month: 'long',
          }).format(new Date(daten.pause_bis + 'T00:00:00Z'));
          const text = d.textPause.replace('__DATUM__', datum);
          if (feld.textContent !== text) feld.textContent = text;
          // Gesamtdauer nennen; die Zusatzzeit ist darin bereits enthalten.
        } else if (Number.isFinite(jetzt) && jetzt >= 0 && d.text) {
          const template = addon > 0 && d.textAddon ? d.textAddon : d.text;
          const text = jetzt === 1 && addon === 0 && d.textOne ? d.textOne : template.replace('__TAGE__', String(jetzt));
          if (feld.textContent !== text) feld.textContent = text;
        }
        this.hidden = false;
      }
    }
  );
}
